import React from 'react';
import PropTypes from 'prop-types';
import { handleImgOnError, addVersionId } from '~/utils/helpers';
import Draggable from '~/components/Draggable';

function CardArt({ cardArt }) {
    return (
        <Draggable fieldName="draggableCardArt">
            <img
                src={addVersionId(cardArt)}
                style={{
                    width: 'inherit',
                    height: 'inherit',
                }}
                id="cardArt"
                draggable={false}
                onError={handleImgOnError}
                crossOrigin="anonymous"
            />
        </Draggable>
    );
}

CardArt.defaultProps = {
    cardArt: '',
};
CardArt.propTypes = {
    cardArt: PropTypes.string,
};
export default React.memo(CardArt);
